import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../common/config';
import { GoogleMap, MapMarker, MapInfoWindow } from '@angular/google-maps';

@Component({
  selector: 'app-global-map',
  templateUrl: './global-map.component.html',
  styleUrls: ['./global-map.component.css'],
})
export class GlobalMapComponent implements OnInit {
  private URL: string =
    AppSettings.GLOBAL_ORGANIZATION_MAP_LIST +
    AppSettings.GLOBAL_ORGANIZATION_MAP_LIST_APIKEY;

  zoom = 2;
  center: google.maps.LatLngLiteral = { lat: 35.0, lng: 5.0 };
  height: number = Math.floor(window.innerHeight * 0.7);
  scriptLoaded = false;
  locations: Location[] = [];
  error = false;
  loading = true;

  @ViewChild(GoogleMap) map: GoogleMap;
  @ViewChildren(MapMarker) markerElems: QueryList<MapMarker>;
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
selectedLocation: Location | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    // ensure Google Maps API is loaded
    this.ensureGoogleMaps().then(() => {
      this.scriptLoaded = true;
      this.http.get(this.URL).subscribe(
        (response: any) => {
          this.error = false;
          let indexLatitude = -1;
          let indexLocation = -1;
          let indexLongitude = -1;
          let indexUrlToLocationPage = -1;

          response['values'].map((locationData: any) => {
            if (locationData.indexOf('latitude') !== -1) {
              indexLatitude = locationData.indexOf('latitude');
              indexLocation = locationData.indexOf('location');
              indexLongitude = locationData.indexOf('longitude');
              indexUrlToLocationPage = locationData.indexOf(
                'URL to location page'
              );
            } else {
              if (
                indexLatitude !== -1 &&
                indexUrlToLocationPage !== -1 &&
                indexLocation !== -1 &&
                indexLongitude !== -1 &&
                locationData[indexLatitude]
              ) {
                const l: Location = {
                  latitude: +locationData[indexLatitude],
                  URL: locationData[indexUrlToLocationPage],
                  name: locationData[indexLocation],
                  longitude: +locationData[indexLongitude],
                };
                this.locations.push(l);
              }
              this.loading = false;
            }
          });
        },
        (error: any) => {
          this.loading = false;
          this.error = true;
        }
      );
    });
  }

  mapClick() {
    this.infoWindow?.close();
  }

  openInfo(marker: MapMarker, location: Location) {
     this.selectedLocation = location;
     this.infoWindow.open(marker);
  }

  /** Utility: load Google Maps script if not already loaded */
  private ensureGoogleMaps(): Promise<void> {
    return new Promise((resolve) => {
      if ((window as any).google && (window as any).google.maps) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyCsG1DwuyKnJYGoLJ-EKCgsyxGK-ghDfBk';
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      document.head.appendChild(script);
    });
  }
}

interface Location {
  name: string;
  URL: string;
  latitude: number;
  longitude: number;
}
